import { render, staticRenderFns } from "./BaseCustomerGroupDialogSelector.vue?vue&type=template&id=bcec2330"
import script from "./BaseCustomerGroupDialogSelector.vue?vue&type=script&lang=js"
export * from "./BaseCustomerGroupDialogSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports